import React from 'react'
import Header from '../_components/common/Header'
import CMSUI from '../_components/UI/CMSUI'

const CMS = () => {
  return (
    <div className='page-main'>
        <Header name = {["Content Management"]} />
        <CMSUI />
    </div>
  )
}

export default CMS